<template>
  <v-layout d-flex column>
    <v-text-field
      label="Price"
      v-model="price"
      type="number"
    />

    <v-layout v-if="isDiscount">
      <v-flex xs6 v-if="isDiscountInPercent">
        <h4>Discount in percent: </h4> {{discountInPercent * 100}} %
      </v-flex>
      <v-flex xs6 v-if="isDiscountInCurrency">
        <h4>Discount in currency: </h4> {{discountInCurrency}}
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs6>
        <h4>Price without VAT Id: </h4> {{priceWithoutVatId}}
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs6>
        <h4>Price without VAT Id and with discount: </h4> {{priceWithoutVatIdAndWithDiscount}}
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs6>
        <h4>Price with discount:</h4> {{priceWithDiscount}}
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { clone, path, pathOr} from 'ramda'

export default {
  name: 'package-price-counter',
  props: ['defaultPrice', 'discountInCurrency', 'discountInPercent'],
  data () {
    return {
      price: 0
    }
  },
  computed: {
    ...mapGetters([
      'getSettings'
    ]),
    vatId () {
      return pathOr(0, ['globalSetting', 'vatIdSettings', 'increasingPercent'], this.getSettings)
    },
    isDiscountInCurrency () {
      return !!this.discountInCurrency
    },
    isDiscountInPercent () {
      return !!this.discountInPercent
    },
    isDiscount() {
      return this.isDiscountInCurrency || this.isDiscountInPercent
      return this.isDiscountInCurrency || this.isDiscountInPercent
    },
    priceWithoutVatId () {
      const price = parseInt(this.price)
      return price + (price * this.vatId)
    },
    priceWithoutVatIdAndWithDiscount () {
      if (this.isDiscountInPercent) {
        return this.priceWithoutVatId - (this.priceWithoutVatId * this.discountInPercent)
      } else if (this.isDiscountInCurrency) {
        return this.priceWithoutVatId - this.discountInCurrency
      } else {
        return this.priceWithoutVatId
      }
    },
    priceWithDiscount () {
      const price = parseInt(this.price)
      if (this.isDiscountInPercent) {
        return this.defaultPrice - (price * this.discountInPercent)
      } else if (this.isDiscountInCurrency) {
        return price - this.discountInCurrency
      } else {
        return price
      }
    }
  },
  mounted () {
    if (this.defaultPrice) {
      this.price = parseInt(this.defaultPrice)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/APackagePriceCounter/index.vue